module.exports = __webpack_public_path__ + "img/natudrin-depoimento-1.42b4ad3d.jpg";